import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';
import updateStoreData from '#shared/util/updateStoreData.js';

/**
 * Return order data stored in SessionStore and set it to Vuex store
 */
export default defineThemeMiddleware(({ store, response }) => {
	const { sessionStore } = response.locals;
	if (sessionStore.store.submittedCart) {
		updateStoreData(store, sessionStore.store.submittedCart);
	}
}, (context) => context.isServerProcess);
